module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    attrs: {
      "id": "teinte"
    }
  }, [_c('section', {
    attrs: {
      "id": "teinteDesktop"
    }
  }, [_c('div', {
    staticClass: "rel",
    attrs: {
      "id": "Teinte"
    }
  }, [(this.$route.name === 'Module') ? _c('section', {
    class: _vm.relatedProducts(),
    attrs: {
      "id": "productsModule"
    }
  }, [_c('section', {
    attrs: {
      "id": "ticketStrips"
    }
  }, [_c('h2', {
    staticClass: "txtCenter ff-medium rel",
    attrs: {
      "id": "title"
    }
  }, [_vm._v("\n                        TICKET STRIPS\n                        "), (
    (_vm.getDetails(this.$route.params.id).type === 'product' && _vm.hasAccessUpdate('product_manager')) ||
    (_vm.getDetails(this.$route.params.id).type === 'module' && _vm.hasAccessUpdate('module_manager'))
  ) ? _c('button', {
    staticClass: "btn abs pointer mobileNot ff-light uppercase",
    attrs: {
      "id": "edit"
    },
    on: {
      "click": _vm.addStripsItems
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$t("product.ticket")) + "\n                        ")]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.findRelatedTicketsStrip), function(n, index) {
    return _c('div', {
      key: n.big,
      attrs: {
        "id": "imgTicket"
      }
    }, [_c('img', {
      staticClass: "block center fleft shadesPosition flexContainer fw-w mobileNot pointer",
      attrs: {
        "src": _vm.getImgPathFig(n.figures.big, 'big'),
        "id": 'smallPhoto' + n.figures.big,
        "width": "50%"
      },
      on: {
        "click": function($event) {
          _vm.openTicket(n.id);
        }
      }
    })])
  }), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('p', {
    staticClass: "link"
  })], 2)]) : _vm._e()])]), _vm._v(" "), (_vm.showModalStrips) ? _c('ModalStrips', {
    attrs: {
      "itemType": _vm.itemType,
      "stripsItem": _vm.stripsItem
    },
    on: {
      "closeModal": function($event) {
        _vm.modalClose($event);
      },
      "relatedItemSaved": function($event) {
        _vm.addedItem($event);
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f1a8f71c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/product/TicketStrip.vue
// module id = 3398
// module chunks = 0